export default {"src":"/_next/static/media/stears-dashboard.a98e7071.svg","height":377,"width":608,"blurWidth":0,"blurHeight":0};